import { useMemo, useState, useEffect, useRef } from "react"
import { Link, useLocation } from "react-router-dom"

// styles
import "@/assets/scss/app/aside.scss"

// images
import brandImage from "@/assets/img/aside/brand.svg"
import accountingImage from "@/assets/img/aside/icons/accounting.svg"
import todoImage from "@/assets/img/aside/icons/todo.svg"
import dashboardImage from "@/assets/img/aside/icons/dashboard.svg"
import scheduleImage from "@/assets/img/aside/icons/schedule.svg"
import analyticsImage from "@/assets/img/aside/icons/analytics.svg"
import partsImage from "@/assets/img/aside/icons/parts.svg"
import contractorsImage from "@/assets/img/aside/icons/contractors.svg"
import relationshipsImage from "@/assets/img/aside/icons/relationships.svg"
import communicationImage from "@/assets/img/aside/icons/communication.svg"
import companyImage from "@/assets/img/aside/icons/company.svg"
import websiteImage from "@/assets/img/aside/icons/website.svg"

// providers
import { useAuthDataContext } from "@/_providers/Auth"

const ADMIN_MENU_ITEMS = [
  {
    segment: "partners",
    route: "/partners",
    title: "Сервизи",
    permission: "partners",
    icon: null,
    children: [],
  },
  {
    segment: "branches",
    route: "/branches",
    title: "Клонове",
    permission: "branches",
    icon: null,
    children: [],
  },
  {
    segment: "licenses",
    route: "/licenses",
    title: "Лицензи",
    permission: "licenses",
    icon: null,
    children: [
      { route: "/licenses", title: "Основни лицензи" },
      { route: "/licenses/configurator", title: "Конфигуратор" },
    ],
  },
  {
    segment: "sms-package",
    route: "/sms-package",
    title: "SMS Пакети",
    permission: "licenses",
    icon: null,
    children: [],
  },
  {
    segment: "accounting",
    route: "/accounting",
    title: "Счетоводство",
    permissions: ["invoices", "accounts", "expenses", "banktransactions"],
    icon: null, //accountingImage,
    children: [
      { route: "/accounting", title: "Фактури", permission: "invoices" },
      {
        route: "/accounting/accounts",
        title: "Справки",
        permission: "accounts",
      },
      {
        route: "/accounting/expenses",
        title: "Разходи",
        permission: "expenses",
      },
      {
        route: "/accounting/banktransactions",
        title: "Банкови операции",
        permission: "banktransactions",
      },
    ],
  },
  {
    segment: "todo",
    route: "/todo",
    title: "Бележки",
    permission: "todos",
    icon: null, //todoImage,
    children: [],
  },
  {
    segment: "admins",
    route: "/admins",
    title: "Потребители",
    superAdminOnly: true,
    icon: null,
    children: [],
  },
  {
    segment: "settings",
    route: "/settings",
    title: "Настройки",
    superAdminOnly: true,
    icon: null,
    children: [],
  },
]

const SERVICE_MENU_ITEMS = [
  {
    segment: "",
    route: "/",
    title: "Табло",
    permission: "dashboard",
    icon: dashboardImage,
    children: [],
  },
  {
    segment: "schedule",
    route: "/schedule",
    title: "План за работа",
    permission: "schedule",
    icon: scheduleImage,
    children: [
      {
        route: "/schedule",
        title: "План за работа",
        permission: "schedule.plan",
      },
      {
        route: "/schedule/reservations",
        title: "Резервации",
        permission: "schedule.reservations",
      },
      {
        route: "/schedule/manuals",
        title: "Наръчници",
        permission: "schedule.manuals",
      },
    ],
  },
  {
    segment: "analytics",
    route: "/analytics",
    title: "Аналитичен модул",
    permission: "analytics",
    icon: analyticsImage,
    children: [
      {
        route: "/analytics",
        title: "Техници",
        permission: "analytics.technicians",
      },
      {
        route: "/analytics/realtime",
        title: "В реално време",
        permission: "analytics.realtime",
      },
      {
        route: "/analytics/clients",
        title: "Клиенти",
        permission: "analytics.clients",
      },
      {
        route: "/analytics/trends",
        title: "Тенденции",
        permission: "analytics.trends",
      },
    ],
  },
  {
    segment: "parts",
    route: "/parts/storage",
    title: "Склад части",
    permission: "parts",
    icon: partsImage,
    children: [
      { route: "/parts/storage", title: "Части" },
      { route: "/parts/appliances", title: "Уреди" },
      //   { route: "/parts/list", title: "Склад" },
      { route: "/parts/most-used", title: "Често използвани" },
      { route: "/parts/suppliers", title: "Доставчици" },
      { route: "/parts/stats", title: "Статистика" },
      { route: "/parts/online-sales", title: "Онлайн продажби" },
    ],
  },
  {
    segment: "contractors",
    route: "/contractors?tab=dashboard",
    title: "Договорни компании",
    permission: "contractors",
    icon: contractorsImage,
    children: [
      {
        route: "/contractors?tab=dashboard",
        title: "Фирми",
        permission: "contractors.companies",
      },
      {
        route: "/contractors/subscriptions",
        title: "Абонаменти",
        permission: "contractors.companies",
      },
      {
        route: "/contractors/warranties",
        title: "Гаранции",
        permission: "contractors.companies",
      },
      // {
      //   route: "/contractors?tab=dashboard",
      //   title: "Табло",
      //   permission: "contractors.companies",
      //   matchSearch: "tab=dashboard",
      // },
      // {
      //   route: "/contractors?tab=list",
      //   title: "Компании",
      //   permission: "contractors.companies",
      //   matchSearch: "tab=list",
      // },
      // {
      //   route: "/contractors?tab=types&types=subscriptions",
      //   title: "Абонаменти",
      //   permission: "contractors.subscriptions",
      //   matchSearch: "tab=types",
      // },
      // {
      //   route: "/contractors?tab=stats",
      //   title: "Статистика",
      //   permission: "contractors.guarantees",
      //   matchSearch: "tab=stats",
      // },
      // {
      //   route: "/contractors?tab=servicing",
      //   title: "Сервизиране",
      //   permission: "contractors.guarantees",
      //   matchSearch: "tab=servicing",
      // },
    ],
  },
  {
    segment: "relationships",
    route: "/relationships?tab=dashboard",
    title: "Партньори",
    icon: relationshipsImage,
    children: [
      {
        route: "/relationships?tab=dashboard",
        title: "Табло",
        permission: "partners.dashboard",
        matchSearch: "tab=dashboard",
      },
      {
        route: "/relationships?tab=list&page=1&group=sent",
        title: "На които отдаваме резерв.",
        permission: "partners.shared_from_us",
        matchSearch: "group=sent",
      },
      {
        route: "/relationships?tab=list&page=1&group=received",
        title: "Които ни отдават резерв.",
        permission: "partners.shared_with_us",
        matchSearch: "group=received",
      },
      {
        route: "/relationships/selfemployed",
        title: "Външни техници",
        permission: "partners.external_techs",
      },
    ],
  },
  {
    segment: "accounting",
    route: "/accounting",
    title: "Счетоводство",
    permissions: ["invoices", "accounts", "expenses", "banktransactions"],
    icon: accountingImage,
    children: [
      { route: "/accounting", title: "Фактури", permission: "invoices" },
      {
        route: "/accounting/unpaid-reservations",
        title: "Неплатени резервации",
        permission: "invoices",
      },
      {
        route: "/accounting/accounts",
        title: "Справки",
        permission: "accounts",
      },
      {
        route: "/accounting/expenses",
        title: "Разходи",
        permission: "expenses",
      },
      {
        route: "/accounting/banktransactions",
        title: "Банкови операции",
        permission: "banktransactions",
      },
    ],
  },
  {
    segment: "todo",
    route: "/todo",
    title: "Бележки",
    permission: "todos",
    icon: todoImage,
    children: [],
  },
  {
    segment: "communication",
    route: "/communication",
    title: "Комуникация",
    permissions: ["sms", "voicecalls"],
    icon: communicationImage,
    children: [
      { route: "/communication", title: "Съобщения", permission: "sms" },
      {
        route: "/communication/voicecalls",
        title: "Обаждания",
        permission: "voicecalls",
      },
    ],
  },
  {
    segment: "company",
    route: "/company",
    title: "Настройки",
    permissions: ["company", "settings.main", "bonuspolicy"],
    icon: companyImage,
    children: [
      {
        route: "/company",
        title: "Основни настройки",
        permission: "settings.main",
      },
      {
        route: "/company/bonuspolicies",
        title: "Бонус политики",
        permission: "bonuspolicy",
      },
    ],
  },
  {
    segment: "website",
    route: "/website",
    title: "Уебсайт",
    permission: "website",
    icon: websiteImage,
    children: [],
  },
]

const getFirstSegment = (path) => {
  const cleanPath = path.split("?")[0] // Remove query string
  return cleanPath.split("/").filter(Boolean)[0] || ""
}

function Aside() {
  const { isAdmin, access, permission, isSuperAdmin, isManager } =
    useAuthDataContext()

  const location = useLocation()

  const baseMenuItems = isAdmin() ? ADMIN_MENU_ITEMS : SERVICE_MENU_ITEMS

  const MENU_ITEMS = useMemo(() => {
    return baseMenuItems
      .filter((item) => {
        if (item.superAdminOnly) {
          return isSuperAdmin()
        }

        if (item.permissions) {
          return item.permissions.some((p) => access(p) || permission(p))
        }

        if (item.permission) {
          if (item.permission === "dashboard") {
            return isManager() || permission(item.permission)
          }
          return access(item.permission) || permission(item.permission)
        }

        return true
      })
      .map((item) => {
        if (item.children && item.children.length > 0) {
          const filteredChildren = item.children.filter((child) => {
            if (!child.permission) return true
            return access(child.permission) || permission(child.permission)
          })
          return { ...item, children: filteredChildren }
        }
        return item
      })
  }, [baseMenuItems, isAdmin, isSuperAdmin, isManager, access, permission])

  const asideRef = useRef(null)

  const currentSegment = useMemo(
    () => getFirstSegment(location.pathname),
    [location.pathname],
  )

  const [expandedSegment, setExpandedSegment] = useState(currentSegment)

  useEffect(() => {
    setExpandedSegment(currentSegment)
  }, [currentSegment])

  const handleParentClick = (e, segment, hasChildren) => {
    e.stopPropagation()
    if (hasChildren && window.innerWidth <= 1100) {
      e.preventDefault()
    } else if (!hasChildren) {
      asideRef.current.classList.remove("visable-aside")
      document.querySelector("body").classList.remove("blured-content")
    }
    setExpandedSegment((prev) => (prev === segment ? "" : segment))
  }

  const handleSubLinkClick = () => {
    asideRef.current.classList.remove("visable-aside")
    document.querySelector("body").classList.remove("blured-content")
    setExpandedSegment(currentSegment)
  }

  useEffect(() => {
    const el = asideRef.current
    if (!el) return

    const observer = new MutationObserver(() => {
      if (!el.classList.contains("visable-aside")) {
        setExpandedSegment(currentSegment)
      }
    })

    observer.observe(el, { attributes: true, attributeFilter: ["class"] })
    return () => observer.disconnect()
  }, [currentSegment])

  const isExpanded = (segment) => segment === expandedSegment

  const isActive = (item) => {
    if (item.matchSearch) {
      return location.search.includes(item.matchSearch)
    }

    const itemPath = item.route.split("?")[0]

    return location.pathname === itemPath
  }

  return (
    <aside ref={asideRef}>
      <div className="head">
        <img src={brandImage} alt="Engineering United System" />
        <p>Engineering United System</p>
      </div>
      <ul className="main">
        {MENU_ITEMS.map(({ segment, route, title, children, icon }) => {
          const hasChildren = children && children.length > 0
          const expanded = isExpanded(segment)
          const parentActive =
            expandedSegment && expandedSegment !== currentSegment
              ? segment === expandedSegment
              : segment === currentSegment

          return (
            <li key={segment} className={parentActive ? "active" : ""}>
              <Link
                to={route}
                onClick={(e) => handleParentClick(e, segment, hasChildren)}
              >
                <img src={icon} alt="" />
                {title}
              </Link>
              {hasChildren && expanded && (
                <ul>
                  {children.map((child) => (
                    <li
                      key={child.route}
                      className={isActive(child) ? "active" : ""}
                    >
                      <Link to={child.route} onClick={handleSubLinkClick}>
                        {child.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          )
        })}
      </ul>
    </aside>
  )
}

export default Aside
